// extracted by mini-css-extract-plugin
export var editButton = "_lg-0";